































import {Vue, Component, Prop} from "vue-property-decorator";


@Component({
  components: {}
})
export default class ForgotPasswordForm extends Vue {
  public name: string = "ForgotPasswordForm";

  @Prop({required: false, default: false})
  public reset!: boolean;

  @Prop({required: false, default: null})
  public errors!: any;

  protected showErrors = true;

  protected email: string = "";

  public onSubmit(): void {

    this.$emit("submit", {
      email: this.email,
    });

    this.showErrors = false;

    if (this.reset) {
      this.email = "";

    }
  }


  mounted() {

  }
}
